import React from 'react';
import { Box, FormControl, Select, MenuItem, Typography } from '@mui/material';

const SORT_OPTIONS = [
  { value: '_score', label: 'Relevance' },
  { value: 'date_desc', label: 'Date (newest)' },
  { value: 'date_asc', label: 'Date (oldest)' },
  { value: 'title_asc', label: 'Title A-Z' },
  { value: 'title_desc', label: 'Title Z-A' },
];
const DEFAULT_SORT = '_score';

/**
 * SortSelector - Dropdown to select the result sort order
 *
 * @param {string} value - Current sort token
 * @param {function} onChange - Callback when sort changes
 * @param {string} label - Optional leading label text (default: "Sort by")
 */
export default function SortSelector({ value, onChange, label = 'Sort by' }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <FormControl size="small" sx={{ minWidth: 130 }}>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Sort results"
          inputProps={{ 'aria-label': 'Sort results' }}
          sx={{
            '& .MuiSelect-select': { py: 0.5 },
            fontSize: '0.875rem'
          }}
        >
          {SORT_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export { SORT_OPTIONS, DEFAULT_SORT };
